<form [formGroup]="leningenFG">
    <div *ngIf="leningen.length > 0">
        <div formArrayName="leningen">
            <div *ngFor="let lening of leningen.controls; let i = index; "
                 [formGroupName]="i">
                <div formArrayName="kosten">
                    <div *ngFor="let leninggroup of getKosten(i).controls; let k = index "
                         [formGroupName]="k" class="row">
                        <snelstart-ui-select-form-control (change)="saveForm()"


                                                          [label]="k === 0 ? 'Soort kosten' : ''"
                                                          [options]="soortFinancieringskosten"
                                                          class="custom-input-250 col-auto"
                                                          formControlName="omschrijving"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [label]="k === 0 ? 'Bedrag' : ''"
                                                          align="right"
                                                          class="custom-input-150 col-auto"
                                                          formControlName="bedrag"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-button (click)="deleteKosten(i, k)"
                                             [class]="k === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                             icon="trash"
                                             iconType="light"
                                             id="buttonDeleteKosten"
                                             size="medium"
                                             type="secondary"
                        >
                        </snelstart-ui-button>
                    </div>
                </div>
                <div *ngIf="i === 0 && getKosten(i).length === 0">
                    <snelstart-ui-button (click)="addKosten(i)" class="snelstart-ui-button pb-3" icon="plus"
                                         type="link">Kosten invullen
                    </snelstart-ui-button>
                </div>
                <div *ngIf="i === 0 && getKosten(i).length > 0">
                    <snelstart-ui-button (click)="addKosten(i)" class="snelstart-ui-button pb-3" icon="plus"
                                         type="link">Kosten toevoegen
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>

</form>

<div *ngIf="leningen.length === 0">
    <snelstart-ui-button (click)="addLening()" class="snelstart-ui-button" icon="plus"
                         type="link">Kosten invullen
    </snelstart-ui-button>
</div>


